export function getRandomString(length: number, uppercase = true) {
    let str = '';
    for (let i = 0; i < length; i++) {
        str += getRandomLetter();
    }
    return uppercase ? str.toUpperCase() : str;
}

export function getRandomLetter() {
    const alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','x','w','y','z'];
    const idx = getRandomInt(0, alphabet.length -1);
    return alphabet[idx];
}

// src: https://stackoverflow.com/questions/1527803/generating-random-whole-numbers-in-javascript-in-a-specific-range
export function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}